import { Box, Paper, Typography } from '@mui/material';
// @mui
import { alpha } from '@mui/material/styles';
import { FileRejection } from 'react-dropzone';

import { useStrings } from 'src/hooks/useStrings';

// utils
import { fData } from '../../utils/formatNumber';
import getFileData from '../../utils/getFileData';

// ----------------------------------------------------------------------

type Props = {
  fileRejections: FileRejection[];
};

export default function RejectionFiles({ fileRejections }: Props) {
  const { strings } = useStrings();
  fileRejections.forEach((fileRejection) => {
    let errors = fileRejection.errors.map((error) => {
      if (error.code === 'too-many-files')
        error.message = strings('imageUploaderRejection');
      return error;
    });
    fileRejection.errors = errors;
  });

  return (
    <Paper
      variant="outlined"
      sx={{
        py: 1,
        px: 2,
        mt: 3,
        borderColor: 'error.light',
        bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
      }}
    >
      {fileRejections.map(({ file, errors }, idx) => {
        const { path, size } = getFileData(file);

        return (
          <Box key={path} sx={{ my: 1 }}>
            <Typography variant="subtitle2" noWrap>
              {idx + 1}. {path} - {size ? fData(size) : ''}
            </Typography>

            {errors.map((error) => (
              <Box
                key={error.code}
                component="li"
                sx={{ typography: 'caption' }}
              >
                {error.message}
              </Box>
            ))}
          </Box>
        );
      })}
    </Paper>
  );
}
